<template>
  <div class="page-component-wrapper">
    <grid
      :config="gridConfig"
    >
      <template v-slot:column-control-left="{ row }">
        <li>
          <ui-button @click="partID = row.partID" class="btn btn-size-xs" :disabled="!row.partID">
            {{L10n('stock-info')}}
          </ui-button>
        </li>
      </template>
    </grid>
    <editor
      :disabled="isDisabledForm"
      :config="{ id: gridConfig.id, api: 'RFQs/Get/' }"
      :moduleName="moduleName"
    />
    <check-stock
      :is-visible="isVisible"
      :partID="partID"
      @close="partID = null"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig'
import StoreModule from './StoreModule.js'
export default {
  name: 'RFQPendingIndex',
  components: {
    'check-stock': () => import(/* webpackChunkName: 'RFQPending' */ './CheckStock'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'RFQPending' */ './Editor')
  },
  created () {
    const store = this.$store
    const moduleName = this.moduleName
    if (store && !store.state[moduleName]) {
      store.registerModule(moduleName, StoreModule)
    }
  },
  beforeDestroy () {
    this.$store.dispatch(`${this.moduleName}/resetState`)
  },
  data () {
    return {
      moduleName: 'rfq-pending',
      partID: null
    }
  },
  computed: {
    gridConfig () {
      let currentUser = this.$store.getters.get('currentUser')
      return gridConfig({ employeeID: currentUser.employeeID || null })
    },
    isDisabledForm () {
      return !this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    },
    isVisible () {
      return Boolean(this.partID)
    }
  }
}
</script>
